import React from "react";

const NoBrandImage = ({scale}: {scale?: number}) => {
  return (
    <svg transform={`scale(${scale||1})`} width="44" height="44" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <g>
      <rect x="3" y="3" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="1.6" opacity="0.65" />
      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" opacity="0.65" />
      <path d="M21 15l-4.2-4.2a1 1 0 0 0-1.4 0L9 17l-2.1-2.1a1 1 0 0 0-1.4 0L3 17" stroke="currentColor" strokeWidth="1.6" opacity="0.65" />
      </g>
    </svg>
  )
}

export default NoBrandImage;
